// rewardsService.js
import { auth } from "../firebase";

export async function claimDailyReward() {
  if (!auth.currentUser) throw new Error("User not signed in.");

  const token = await auth.currentUser.getIdToken();

  const res = await fetch("https://us-central1-stockmarket-83a73.cloudfunctions.net/dailyItemReward", {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json"
    }
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.message || `Server error: ${res.status}`);
  }

  return data;
}